import { NgModule, InjectionToken } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgxSpinnerModule } from "ngx-spinner";
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ModalModule } from './components/modal';

import { ClientTokenInterceptor } from './interceptors/client-token.interceptor';
import { FooterComponent } from './components/footer/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { SanitiseHtmlPipe } from './pipes/sanitise-html.pipe';
import { FourOhFourModule } from './404/four-oh-four.module';

// full calendar
// import { FullCalendarModule } from '@fullcalendar/angular';
// import dayGridPlugin from '@fullcalendar/daygrid'; // plugin
// import interactionPlugin from '@fullcalendar/interaction'; // plugin
import { FormBuilderComponent } from './components/form-builder/form-builder.component';
import { AccessComponent } from './journey/access/access.component';
import { OurCeremonyComponent } from './journey/our-ceremony/our-ceremony.component';
import { MenuComponent } from './components/menu/menu.component';
import { ChecklistComponent } from './journey/checklist/checklist.component';
import { PaymentInformationComponent } from './journey/payment-information/payment-information.component';
import { MyAddOnsComponent } from './journey/my-add-ons/my-add-ons.component';
import { GiveNoticeComponent } from './journey/give-notice/give-notice.component';
import { CeremonyChoicesComponent } from './journey/ceremony-choices/ceremony-choices.component';
import { TermsAndConditionsComponent } from './journey/terms-and-conditions/terms-and-conditions.component';
import { FaqsComponent } from './journey/faqs/faqs.component';
import { CommunicationComponent } from './journey/communication/communication.component';
import { CustomObjectBannerComponent } from './components/custom-object-banner/custom-object-banner.component';
import { CustomObjectAccordionComponent } from './components/custom-object-accordion/custom-object-accordion.component';

import { PaymentAmountComponent } from './components/payment-amount/payment-amount.component';
import { IPayment } from './interfaces/ipayment';
import { CapitaService } from './services/capita.service';
import { CivicaService } from './services/civica.service';
import { StripeService } from './services/stripe.service';
import { HeycentricService } from './services/heycentric.service';
import { PaymentVerifyComponent } from './journey/payment-verify/payment-verify.component';
import { EnhancementsComponent } from './journey/enhancements/enhancements.component';

// FullCalendarModule.registerPlugins([ // register plugin(s)
//   dayGridPlugin,
//   interactionPlugin
// ]);

export const PaymentServiceTokens: Map<
	string,
	InjectionToken<IPayment>
> = new Map();
// Add File service implementation token
PaymentServiceTokens.set('capita', new InjectionToken<IPayment>('capita'));
PaymentServiceTokens.set('civica', new InjectionToken<IPayment>('civica'));
PaymentServiceTokens.set('stripe', new InjectionToken<IPayment>('stripe'));
/**
 * TODO: Update heycentric service token to use heycentric service instead of capital once created
 */
PaymentServiceTokens.set('heycentric', new InjectionToken<IPayment>('heycentric'));

// required for AOT compilation
export function HttpLoaderFactory(httpClient: HttpClient) {
	return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}
@NgModule({
	declarations: [
		AppComponent,
		FooterComponent,
		SanitiseHtmlPipe,
		FormBuilderComponent,
		AccessComponent,
		OurCeremonyComponent,
		ChecklistComponent,
		PaymentInformationComponent,
		MyAddOnsComponent,
		GiveNoticeComponent,
		CeremonyChoicesComponent,
		TermsAndConditionsComponent,
		FaqsComponent,
		CommunicationComponent,
		CustomObjectBannerComponent,
		CustomObjectAccordionComponent,
		PaymentAmountComponent,
		PaymentVerifyComponent,
	],
	exports: [TranslateModule],
	bootstrap: [AppComponent],
	imports: [
		BrowserModule,
		AppRoutingModule,
		HeaderComponent,
		NgxSpinnerModule,
		BrowserAnimationsModule,
		ModalModule,
		FormsModule,
		ReactiveFormsModule,
		FourOhFourModule,
		// FullCalendarModule,
		// NgQRCodeReaderModule,
		MenuComponent,
		EnhancementsComponent,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient],
			},
		}),
	],
	providers: [
		{
			provide: HTTP_INTERCEPTORS,
			useClass: ClientTokenInterceptor,
			multi: true,
		},
		{
			provide: PaymentServiceTokens.get('capita'),
			useClass: CapitaService,
		},
		{
			provide: PaymentServiceTokens.get('civica'),
			useClass: CivicaService,
		},
		{
			provide: PaymentServiceTokens.get('stripe'),
			useClass: StripeService,
		},
		{
			provide: PaymentServiceTokens.get('heycentric'),
			useClass: HeycentricService
		},
		provideHttpClient(withInterceptorsFromDi()),
	],
})
export class AppModule {}
